import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonService } from '../../service/common.service';
import { Commessa } from '../../models/commessa';
import { Lavorazione } from '../../models/lavorazione';
import { Statolavorazione } from '../../models/statolavorazione';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { configurazione } from '../../../configurazioni/configurazione';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'app-lavorazioni',
  templateUrl: './lavorazioni.component.html',
  styleUrls: ['./lavorazioni.component.css']
})
export class LavorazioniComponent implements OnInit {
  selectedValueStato:string;
  lavorazioni: Lavorazione[]=[];
  stati: Statolavorazione[];
  stato: Statolavorazione;
  codicecommessa:number;
  nomestatocommessa:string;
//  currentAzienda:Azienda;
  displayedColumns: string[] = [
    "Codice",
    "Nome",
    "Stato",
    "articolilavorazione",
    "edit",
    "delete"];

  sortedDirection:Map<string, boolean>=new Map<string, boolean>();

  dataSource = new MatTableDataSource<Lavorazione>(this.lavorazioni);
  @ViewChild('paginator') paginator: MatPaginator;
  constructor(private router: Router, private commonService: CommonService) {}

  ngOnInit() {


    this.commonService.getAllStatilavorazioni().subscribe((res) => {
        this.stati = res;

/*
        this.commesse.forEach(element => {
          if (element.Codice === this.commonService.currentAziendaCodice){
            this.stato=element;
            this.selectedValueAzienda=this.azienda.Nome;
          }
        });
*/
  //      this.manageChangeAzienda();
        this.aggiornaLista();
    });

    this.dataSource.paginator = this.paginator;
    this.sortedDirection.set("Codice",true);
    this.sortedDirection.set("Nome",true);
    this.sortedDirection.set("Stato",true);
    this.sortedDirection.set("articolilavorazione",true);
    this.sortedDirection.set("edit",true);
  }

  manageChangeStato(){
    if (this.selectedValueStato===undefined){
     return;
    }
    this.stati.forEach(element => {
      if (this.selectedValueStato === element.Nome){
        this.stato=element;
      }
    });
    this.aggiornaLista();
  }

  cancel(){
    this.selectedValueStato="";
    this.stato=new Statolavorazione();
    this.aggiornaLista();
  }



  delete(lavorazione: Lavorazione): void {
    this.commonService.deleteLavorazione(lavorazione).subscribe(data => {
      this.lavorazioni = this.lavorazioni.filter(c => c !== lavorazione);
    });
  }


  aggiornaLista(){
    let templistalavorazioni:Lavorazione[]=[];
    this.lavorazioni=[];
  //  if (this.stato!=undefined && this.stato.Nome!=undefined && this.stato.Nome!=""){
     this.commonService.getAllLavorazioni(this.commonService.selectedCommessa.Codice).subscribe((res) => {
       this.codicecommessa=this.commonService.selectedCommessa.Codice;
       this.nomestatocommessa=this.commonService.selectedCommessa.Statocommessa.Nome;
       if (this.stato!=undefined && this.stato.Nome!=undefined && this.stato.Nome!=""){
          templistalavorazioni = res;
          templistalavorazioni.forEach(element => {
              const lavorazione:Lavorazione=element;
              lavorazione.Commessa=this.commonService.selectedCommessa;
              lavorazione.Codicecommessa=this.commonService.selectedCommessa.Codice;
              if (lavorazione.Statolavorazione.Nome===this.stato.Nome){
                lavorazione.Codicestatolavorazione=lavorazione.Statolavorazione.Codice;
                this.lavorazioni.push(lavorazione);
              }
            });
       }else{
         this.lavorazioni=res;
       }
       this.refreshLista(this.lavorazioni);
      });

    }

   refreshLista(listalavorazioni:Lavorazione[]){
     this.lavorazioni=listalavorazioni;
     this.dataSource = new MatTableDataSource<Lavorazione>(this.lavorazioni);
     this.dataSource.paginator = this.paginator;
   }

  new(){
    this.commonService.selectedLavorazione=undefined;
    this.router.navigate(['addlavorazione']);
  }
  edit(lavorazione: Lavorazione): void {
      this.commonService.selectedLavorazione=lavorazione;
      this.router.navigate(['addlavorazione']);
  }

  back(){
    this.commonService.selectedCommessa=undefined;
    this.commonService.selectedLavorazione=undefined;
    this.router.navigate(['commesse']);
  }

  articolilavorazione(lavorazione: Lavorazione): void {
      this.commonService.selectedLavorazione=lavorazione;
      this.router.navigate(['lavorazionearticoli']);
  }

  getConfigurazione(){
    return configurazione.lavorazione;
  }

  manageClick(attributo: string){
    let tempList:Lavorazione[];
    tempList=this.lavorazioni;
    let direction=this.sortedDirection.get(attributo);

    tempList.sort((a, b) => {
       var typeA = "";
       var typeB = "";
       if (a[attributo]!=null){
         if (isNaN(b[attributo]))
            typeA = a[attributo].toLowerCase();
         else
            typeA = a[attributo].toString();
       }
       if (b[attributo]!=null){
         if (isNaN(b[attributo]))
            typeB = b[attributo].toLowerCase();
          else
            typeB = b[attributo].toString();
       }
         if (direction){
           if (typeA > typeB){
             return -1;
           }else if (typeA < typeB){
              return 1;
           }else{
             return 0;
           }
         }else{
           if (typeA < typeB){
             return -1;
           }else if (typeA > typeB){
              return 1;
           }else{
             return 0;
           }
         }
     });
     direction=!direction;
     this.sortedDirection.set(attributo,direction);

     this.dataSource = new MatTableDataSource<Lavorazione>(this.lavorazioni);

   }

}
